import type { ComponentType, ComponentOptions } from '../../types';

export const componentsConfiguration = {
  componentsTypes: [
    'list',
    'slider',
    'splash',
    'editorial',
    'filtered-list',
    'scheduled',
    'continue-watching',
    'carousel',
  ],
  dataSources: {
    // aligned with `dataSchemaConfiguration` in API
    list: [
      {
        dataType: 'assets',
        endpoints: [
          'svp/search',
          'svp/most-seen',
          'svp/assets',
          'curate/blend',
        ],
        preset: true,
      },
      {
        dataType: 'categories',
        endpoints: ['svp/categories'],
        preset: true,
      },
      {
        dataType: 'mixed',
        preset: true,
      },
    ],
    'continue-watching': [
      {
        dataType: 'assets',
        endpoints: ['svp/search', 'svp/assets'],
      },
    ],
    slider: [
      {
        dataType: 'assets',
        endpoints: [
          'svp/search',
          'svp/most-seen',
          'svp/assets',
          'curate/blend',
        ],
        preset: true,
      },
      {
        dataType: 'mixed',
        preset: true,
      },
      {
        dataType: 'stories',
        endpoints: ['svp/search'],
        preset: true,
      },
      {
        dataType: 'categories',
        endpoints: ['svp/categories'],
        preset: true,
      },
      {
        dataType: 'profiles',
        endpoints: ['/profiles'],
        preset: true,
      },
      {
        dataType: 'staylive/streams',
        endpoints: ['staylive/channel'],
      },
      {
        dataType: 'seasons',
      },
    ],
    splash: [
      {
        dataType: 'assets',
        preset: true,
      },
      {
        dataType: 'categories',
        preset: true,
      },
    ],
    carousel: [
      {
        dataType: 'assets',
        endpoints: ['svp/search'],
        preset: true,
      },
      {
        dataType: 'categories',
        preset: true,
      },
      {
        dataType: 'mixed',
        preset: true,
      },
    ],
    editorial: [
      {
        dataType: 'assets',
        preset: true,
      },
    ],
  },
} as const;

/**
 * Per-component-type default options applied on creation and on type-change reset.
 * Lifted from the ad-hoc literals previously scattered in PageForm.tsx.
 *
 * Only keys that differ from "absent" need to be listed; the object is merged
 * over an empty options baseline when a new component is created.
 */
export const componentTypeDefaultOptions: Partial<
  Record<ComponentType, Partial<ComponentOptions>>
> = {
  list: { layout: 'vertical' },
  // filtered-list: usePageTaxonomy default depends on the page type (set
  // dynamically in PageForm.onComponentAddClick) so it is omitted here.
};

/**
 * The 11 option keys that componentOptionsSchema (.strict()) allows.
 * Any key NOT in this set (e.g. the read-only virtual `hasSingleItem`) is
 * stripped from the write payload by pickComponentWritePayload.
 */
export const ALLOWED_OPTIONS_KEYS: ReadonlyArray<keyof ComponentOptions> = [
  'buttonLabel',
  'hideSearchField',
  'isFullFledged',
  'layout',
  'placeholder',
  'sortByEpisodeNumber',
  'sortByFlightTimes',
  'usePageTaxonomy',
  'useVerticalPosters',
  'useLargeThumbnails',
  'skipMetadata',
];
